"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "Button", {
  enumerable: true,
  get: function () {
    return _button.default;
  }
});
_Object$defineProperty(exports, "Step", {
  enumerable: true,
  get: function () {
    return _step.default;
  }
});
_Object$defineProperty(exports, "StepContent", {
  enumerable: true,
  get: function () {
    return _stepcontent.default;
  }
});
_Object$defineProperty(exports, "StepLabel", {
  enumerable: true,
  get: function () {
    return _steplabel.default;
  }
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Stepper = _interopRequireDefault(require("@mui/material/Stepper"));
var _uiTheme = require("@kyruus/ui-theme");
var _step = _interopRequireDefault(require("./step"));
var _steplabel = _interopRequireDefault(require("./steplabel"));
var _stepcontent = _interopRequireDefault(require("./stepcontent"));
var _button = _interopRequireDefault(require("./button"));
const _overrides = theme => ({
  MuiStepConnector: {
    styleOverrides: {
      line: {
        borderColor: theme.color_text_secondary
      }
    }
  },
  MuiStepper: {
    styleOverrides: {
      root: {
        paddingLeft: 0
      }
    }
  }
});
const StepperComponent = (0, _uiTheme.withMuiThemeAdapter)(_Stepper.default, _overrides);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.

const Stepper_ = props => /*#__PURE__*/_react.default.createElement(StepperComponent, props);
Stepper_.displayName = 'Stepper';

// PropTypes taken from material-ui.
Stepper_.propTypes = process.env.NODE_ENV !== 'production' ? {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes.default.number,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes.default.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object,
  /**
   * A component to be placed between each step.
   */
  connector: _propTypes.default.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes.default.bool,
  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
Stepper_.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  nonLinear: false,
  orientation: 'horizontal'
};
var _default = exports.default = Stepper_;
Stepper_.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Stepper",
  "props": {
    "activeStep": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false
    },
    "alternativeLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "nonLinear": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "orientation": {
      "defaultValue": {
        "value": "'horizontal'",
        "computed": false
      },
      "required": false
    }
  }
};